// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicosCategorias_CarregaCategoriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /config/servicos_categorias/carrega_categoria/<id>
 *
 * Returns a single service category. Legacy shape emits the row object
 * directly under `dados`.
 */
import type { ServicosCategorias_CategoriaRow } from './ServicosCategorias_CategoriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServicosCategorias_CarregaCategoriaResponseDados = ServicosCategorias_CategoriaRow;

export type ServicosCategorias_CarregaCategoriaResponse = ApiResponse<ServicosCategorias_CarregaCategoriaResponseDados>;

registerResponseContract('ServicosCategorias_CarregaCategoriaResponse', {
  _nullable:                             { type: 'boolean', required: false },
  servicoscategoria_id:                  { type: 'number',  required: true },
  servicoscategoria_nome:                { type: 'string',  required: true },
  servicoscategoria_prazo_retorno_dias:  { type: 'number',  required: true },
  servicoscategoria_prazo_garantia_dias: { type: 'number',  required: true },
  servicoscategoria_produtos_associados: { type: 'number',  required: true },
})
